<template>
  <h2 class="h3 text-center" v-if="!pagingItem.hasListView">
    Vi har fundet
    <span class="text-secondary">{{ pagingItem.totalNumberOfResults }}</span>
    {{ this.$store.getters.singlePlural(pagingItem) }}
  </h2>
  <div
    :class="[{ initial: pagingItem.initial }, 'card-result-row']"
    :data-length="pagingItem.totalNumberOfResults"
    v-if="
      pagingItem.documentType === 'PageTravel' ||
      pagingItem.documentType === 'PageCruise'
    "
  >
    <page-travel-card
      v-for="(card, index) in tripfinderViewModel.result.items[index].items"
      :key="index"
      :card="card"
    />
  </div>
  <div
    :class="[{ initial: pagingItem.initial }, 'card-result-row']"
    :data-length="pagingItem.totalNumberOfResults"
    v-if="pagingItem.documentType === 'PageHotel'"
  >
    <page-hotel-card
      v-for="(card, index) in tripfinderViewModel.result.items[index].items"
      :key="index"
      :card="card"
    />
  </div>
  <div
    :class="[{ initial: pagingItem.initial }, 'card-result-row']"
    :data-length="pagingItem.totalNumberOfResults"
    v-if="pagingItem.documentType === 'PageExperience'"
  >
    <page-experience-card
      v-for="(card, index) in tripfinderViewModel.result.items[index].items"
      :key="index"
      :card="card"
    />
  </div>
  <div
    class="d-flex mt-5 justify-content-center"
    v-if="
      (pagingItem.initial && pagingItem.totalNumberOfResults > 4) ||
      pagingItem.pageNumber < pagingItem.pagesInAll
    "
  >
    <button
      type="button"
      class="btn border rounded-pill"
      @mousedown="preventFocus"
      :data-initial="pagingItem.initial"
      @click="getMoreResultItems(index)"
    >
      Vis flere
    </button>
  </div>
</template>
<script>
import PageTravelCard from "./PageTravelCard.vue";
import PageHotelCard from "./PageHotelCard.vue";
import PageExperienceCard from "./PageExperienceCard.vue";
export default {
  name: "TripfinderResultCardView",
  props: ["pagingItem", "index"],
  components: {
    PageTravelCard,
    PageHotelCard,
    PageExperienceCard,
  },
  computed: {
    tripfinderViewModel() {
      return this.$store.state.tripfinderViewModel;
    },
  },
  methods: {
    preventFocus: function (event) {
      // Prevents focus styling on click
      event.preventDefault();
    },
    getMoreResultItems: function (index) {
      this.$store.dispatch("getMoreResultItems", index);
    },
  },
};
</script>